import {Component, EventEmitter, Input, Output} from "@angular/core";
import {UserReservation} from "../../../../../../../../../server/src/base/entities/leasing/calendar/UserReservation";
import {Van} from "../../../../../../../../../server/src/base/entities/leasing/Van";

@Component({
    selector: 'admin-user-reservations',
    styleUrls: ['./adminUserReservation.scss'],
    templateUrl: './adminUserReservation.html'
})
export class AdminUserReservationComponent {
    @Input() userReservation:UserReservation;
    @Output() moreDetails:EventEmitter<AdminUserReservationComponent> = new EventEmitter<AdminUserReservationComponent>();
    @Output() updated:EventEmitter<void> = new EventEmitter<void>();
    @Output() validated:EventEmitter<AdminUserReservationComponent> = new EventEmitter<AdminUserReservationComponent>();
    @Output() removed:EventEmitter<void> = new EventEmitter<void>();

    public firstDate:Date;
    public moreDetailed:boolean;
    public van:Van;

    ngOnInit(){
        this.moreDetailed = false;
        var that = this;
        setTimeout(() => {
            if(!this.userReservation.validated){
                let element = document.getElementById(that.userReservation.id);
                element.style.backgroundColor = '#f3f3f3';
            }
        }, 250)
    }

    public Validate(){
        this.userReservation.validated = true;
        let element = document.getElementById(this.userReservation.id);
        element.style.backgroundColor = '#ffffff';
    }

    public DetailsSet(){
        this.moreDetailed = true;
        this.computeFirstDate();
    }

    public detailsRequired(){
        this.moreDetails.emit(this);
    }

    public validationRequired(){
        this.validated.emit(this);
    }

    private computeFirstDate(){
        this.firstDate = new Date(3000, 1,1);
        for(let reservation of this.userReservation.reservations){
            if(this.firstDate.getTime() > reservation.slot.Date().getTime()){
                this.firstDate = reservation.slot.Date();
            }
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/reservations/presentation/adminUserReservation/adminUserReservation.ts